import { render, staticRenderFns } from "./huddle_panel.vue?vue&type=template&id=25a50610&scoped=true&"
import script from "./huddle_panel.vue?vue&type=script&lang=js&"
export * from "./huddle_panel.vue?vue&type=script&lang=js&"
import style0 from "./huddle_panel.vue?vue&type=style&index=0&id=25a50610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a50610",
  null
  
)

export default component.exports